import * as Sentry from '@sentry/react';
import config from 'config';

export function captureException(error: Error, hint?: Sentry.EventHint) {
  if (config.USE_SENTRY) {
    Sentry.captureException(error, hint);
  }
}
